import { ButtonGroup } from '@cad-arc';
import { useDrawerControls } from '../drawers/components/drawer-context-provider';
import { FormCancelButton } from '../forms/integrated-form-components/form-cancel-button';
import { FormSaveButton } from '../forms/integrated-form-components/form-save-button';

export function ServiceRotationDrawerFooter({
    acceptedDisabled,
    onAccepted,
}: {
    acceptedDisabled: boolean;
    onAccepted: () => void;
}) {
    const drawerControls = useDrawerControls();
    return (
        <ButtonGroup>
            <FormCancelButton variant="ghost" onClick={() => drawerControls.close()} />
            <FormSaveButton variant="solid" isDisabled={acceptedDisabled} onClick={onAccepted}>
                Accepted
            </FormSaveButton>
        </ButtonGroup>
    );
}
